import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';
import type { Me } from '../../lib/auth';
import { can } from '../../lib/permissions';
import type { Billing } from '../people/data';

// Datos de /api/licencias (guía 7.6).

export interface LicenseCosts {
  monthly: number;
  annual: number;
  renewalAmount: number | null;
  available: number | null;
  newSeat: number;
}

export interface LicenseSummary {
  id: string;
  name: string;
  platformId: string | null;
  platform: string | null;
  ownerId: string | null;
  owner: string | null;
  billing: Billing;
  baseCost: number;
  shared: boolean;
  renewalDate: string | null;
  seatsPurchased: number | null;
  notes: string | null;
  active: boolean;
  assigned: number;
  costs: LicenseCosts;
}

export interface LicenseList {
  items: Array<LicenseSummary & { can: { manage: boolean } }>;
  totals: { monthly: number; annual: number };
  can: { create: boolean };
}

export interface Assignment {
  id: string;
  userId: string;
  user: string | null;
  organization: string | null;
  startsOn: string;
  endsOn: string | null;
  source: string;
  note: string | null;
  active: boolean;
}

export interface LicenseDetail extends LicenseSummary {
  assignments: Assignment[];
  can: { manage: boolean; editAll: boolean };
}

export interface PersonOption {
  id: string;
  fullName: string;
  email: string;
  organization: string | null;
}

export const useLicenseForm = () => useQuery({ queryKey: ['licencias', 'formulario'], queryFn: () => api<{ platforms: Array<{ id: string; name: string }> }>('/api/licencias/formulario'), staleTime: 5 * 60_000 });

/** Ven Licencias quienes tienen licencias.ver o .gestionar (el administrador de una plataforma entra por su aviso). */
export const canSeeLicenses = (me: Me) => can(me, 'licencias.ver') || can(me, 'licencias.gestionar');
export const canSeeSuppliers = (me: Me) => can(me, 'proveedores.ver') || can(me, 'proveedores.gestionar');

/** Días hasta una fecha AAAA-MM-DD (negativo si ya pasó). */
export function daysUntil(date: string): number {
  const d = new Date();
  const today = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate());
  return Math.round((Date.parse(`${date}T00:00:00Z`) - today) / 86_400_000);
}
